import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/app/soluciones/valor-agregado-cat/(tabs)/layout.tsx");
